<template>
  <v-flex sm12>
    <v-card flat class="tff-size-card">
      <v-layout justify-center pl-4 pt-3>
        <v-flex sm6 pb-4 pt-4 v-if="currentUser">
          <v-layout row wrap justify-center fill-height align-center>
            <v-flex xs8 sm4 lg4 md4 text-md-center>
              <div style="position: relative;">
                <v-hover>
                  <v-img
                    slot-scope="{ hover }"
                    height="160px"
                    width="160px"
                    :src="currentUser.image"
                    :style="`border-radius: 50%; border: 5px solid `+ currentUser.color"
                    @click="dialog = true"
                    class=""
                  >
                    <v-expand-transition>
                      <div
                        v-if="hover"
                        class="d-flex hover transition-fast-in-fast-out v-card--reveal"
                        style="height: 100%;"
                      >
                        <img class="add-photo" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/circle-plus-solid.svg" alt="">
                      </div>
                    </v-expand-transition>
                  </v-img>
                </v-hover>

                <v-layout justify-center row>               
                  <img
                    height="40px"
                    width="40px"
                    src="@/assets/cumple.gif"
                    v-if="currentUser.is_birthday"
                    style="position: absolute; bottom: -1rem; left: 4.4rem; "
                  />
                </v-layout>
              </div>
              <!-- <v-btn color="primary" dark @click="dialog = true">Cambiar imagen</v-btn> -->
              <v-dialog v-model="dialog" max-width="510">
                <v-card>
                  <SimpleUpload @exit="closeModal" />
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click="dialog = false;">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs8 sm8 lg8 md8 pl-2>
              <v-flex sm12 pb-4>
                <v-layout row wrap>                  
                  <v-flex
                    xs12 sm12
                    text-18-security
                    font-weight-bold
                    grey-security
                  >
                    {{currentUser.full_name.charAt(0).toUpperCase() + currentUser.full_name.slice(1)}}
                  </v-flex>
                  <v-flex xs12 sm12 text-14-security grey-security>
                    {{currentUser.position}}
                  </v-flex>
                  
                  <v-flex
                    xs12 sm12
                    text-14-security
                    font-weight-bold
                    grey-security
                  >{{currentUser.company}}</v-flex>
                  <v-flex xs12 sm12 text-14-security grey-security class="tff-center-item mt-2">
                    <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/map-marker.svg" style="width: 17px" alt="address">
                    <span class="pl-1">{{currentUser.address}}</span>
                  </v-flex>
                  <v-flex xs12 sm12 text-14-security grey-security>
                    <a v-bind:href="`tel:${currentUser.phone}`" class="email_phone tff-center-item">
                       <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/phone.svg" style="width: 17px" alt="phone">
                      <span class="pl-1">{{currentUser.annexed}}</span>
                    </a>
                  </v-flex>
                  <v-flex xs12 sm12 text-14-security grey-security>
                    <a v-bind:href="`mailto:${currentUser.email}`" class="email_phone tff-center-item">
                      <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/email-outline.svg"  style="width: 17px" alt="email">
                      <span class="pl-1">{{ " " + currentUser.email }}</span>
                    </a>
                  </v-flex>
                  <v-flex xs12 sm12 text-14-security grey-security class="tff-center-item">
                    <img  grey-security clas="colorp" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg"  style="width: 17px" alt="cake">
                    <span class="pl-1">{{currentUser.birthday}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-layout row wrap>
                <v-btn
                  color="#28385C"
                  class="white--text"
                  round
                  @click="handleCompanyChart()"
                >
                  <img src="@/assets/company-chart.svg" style="height: 1em;" class="pr-2" />
                  Ver Organigrama
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import SimpleUpload from "@/components/User/SimpleUpload";
import { mapActions } from 'vuex';

export default {
  components: {
    SimpleUpload
  },
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("user", ["showHideCompanyChart"]),
    closeModal() {
      this.dialog = false;
    },
    handleCompanyChart() {
      this.showHideCompanyChart()
    }
  },
}
</script>

<style scoped>
@media screen and (min-width: 300px) and (max-width: 450px) {
  .tff-size-card{
    height: 480px;
  }
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  background: rgba(42, 42, 42, 0.4);
  position: absolute;
  width: 100%;
}
.profile {
  color: black;
  text-decoration: inherit;
  padding-left: 14px;
}
.color {
  color: grey;
}

#phone:hover {
  color: grey;
}
#email:hover {
  color: grey;
}
.user-profile {
  border: 3px solid rgb(1, 1, 151);
}

.message {
  color: black;
  text-decoration: inherit;
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}

.email_phone {
  color: #515151;
  text-decoration: inherit;
}

.tff-center-item {
  display: flex;
  align-items: center;
}
.add-photo{
  opacity: 0.6;
}

/* Corrige la posición del icono "add_circle" en Internet Explorer */ 
@media all and (-ms-high-contrast:none){
  *::-ms-backdrop, .tff-position-ie { left: 55px; top: 55px; } /* IE11 */
}
</style>